export default __webpack_public_path__ + "error-person.590d1af5.svg";